import { defaultLocale } from "../constants";
import { BaseDataResponseBody } from "../types";
import { getCurrentLocale, setCurrentLocale, getCurrentBusinessUnitId } from "./cookies";

export const crowdinLocale = "la-LA";

const availableLocales = ["da-DK", "de-DE", "en-GB", "en-US", "es-ES", "fr-FR", "it-IT", "nl-NL", "sv-SE"];

function fixLocaleCasing(locale: string): string {
  const parts = locale.split("-");
  return `${parts[0].toLowerCase()}-${parts[1].toUpperCase()}`;
}

function transformLocale(locale = defaultLocale): string {
  const doesLocaleExist = availableLocales.some(
    (availableLocale) => availableLocale.toLowerCase() === locale.toLowerCase(),
  );
  return doesLocaleExist ? fixLocaleCasing(locale) : defaultLocale;
}

export const resolveLocale = (localeFromBusinessUser: string): string => {
  // Use locale in query string when impersonating
  const query = window.location.search;
  const localeMatch = query.match(/[?&]locale=([\w-]{5})/i);
  const localeMatchValue = localeMatch && localeMatch[1];
  const isImpersonation = query.indexOf("impersonate=true");
  const useQueryStringLocale = isImpersonation !== -1 && localeMatchValue;
  const locale = useQueryStringLocale ? localeMatchValue : getCurrentLocale();

  const finishedLocale = transformLocale(locale || localeFromBusinessUser || defaultLocale);
  setCurrentLocale(finishedLocale);

  return finishedLocale;
};

export const resolveBrowserLocale = (): string => {
  // Use locale in query string when impersonating
  const query = window.location.search;
  const localeMatch = query.match(/[?&]locale=([\w-]{5})/i);
  const localeMatchValue = localeMatch && localeMatch[1];
  const useQueryStringLocale = query.includes("impersonate=true") && localeMatchValue;
  const locale = useQueryStringLocale ? localeMatchValue : getCurrentLocale();

  const finishedLocale = locale ? transformLocale(locale) : "";
  return finishedLocale;
};

export const resolveBrowserBusinessUnitId = (): string => {
  const businessUnitMatch = location.search.toLowerCase().match(/[?&]businessunitid=([\w-]{24})/i);
  const businessUnitIdFromQueryString = businessUnitMatch && businessUnitMatch.length > 1 && businessUnitMatch[1];

  return businessUnitIdFromQueryString || getCurrentBusinessUnitId() || "";
};

export const makeLocaleLocalizationProviderOverride = (
  baseDataLocale: BaseDataResponseBody["locale"],
  isTrustpilotEmployee: boolean,
): string => {
  const qs = new URLSearchParams(window.location.search);

  if (isTrustpilotEmployee && qs.get("crowdin")) {
    return crowdinLocale;
  }

  return baseDataLocale;
};
